import { PlatformType } from '../context/socialProvider';
import { CategoryScores } from '../types/categoryScores';
import { API } from './index';
import Cookies from 'js-cookie';

export const createSocial = async (
  userId: Number,
  provider: Number,
  accessToken: String | null
) => {
  try {
    const response = await API.post('/api/v1/social/create', {
      userId,
      provider,
      accessToken,
    });

    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};

// Update the setMain function to support multiple social IDs
export const setMain = async (
  userId: number,
  instagramSocialId?: number,
  facebookSocialId?: number,
  metaAdsSocialId?: number
) => {
  try {
    const payload: any = { userId };

    if (instagramSocialId) payload.instagramSocialId = instagramSocialId;
    if (facebookSocialId) payload.facebookSocialId = facebookSocialId;
    if (metaAdsSocialId) payload.metaAdsSocialId = metaAdsSocialId;

    const response = await API.post('/api/v1/social/set_main', payload);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getSocials = async (userId: String) => {
  try {
    const response = await API.get('/api/v1/socials/get', {
      params: {
        userId: userId,
      },
    });
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const getSocialMains = async (userId: number) => {
  try {
    const response = await API.get('/api/v1/socials/get-mains', {
      params: {
        userId,
      },
    });
    return response.data.result;
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const updateToken = async (socialId: number, accessToken: string) => {
  console.log(socialId, accessToken);
  try {
    const response = await API.put('/api/v1/social/access_token', {
      id: socialId,
      accessToken: accessToken,
    });

    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateBio = async (id: number, bio: string) => {
  try {
    const response = await API.put(`/api/v1/social/update-bio`, { id, bio });
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateDmInstructions = async (
  id: number,
  dmInstructions: string
) => {
  const authToken = Cookies.get('accessToken');

  try {
    const response = await API.put(
      `/api/v1/social/update-dm-instructions`,
      { id, dmInstructions },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateProfileDescription = async (
  id: number,
  profileDescription: string
) => {
  const authToken = Cookies.get('accessToken');

  try {
    const response = await API.put(
      `/api/v1/social/update-profile-analysis`,
      { id, profileAnalysis: profileDescription },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateAutomod = async (
  socialId: PlatformType,
  autoModActive: boolean,
  autoModInstructions: string,
  categoryScores: CategoryScores
): Promise<void> => {
  const authToken = Cookies.get('accessToken');

  console.log(socialId, autoModActive, autoModInstructions, categoryScores);
  try {
    await API.put(
      `/api/v1/social/update-automod`,
      {
        socialId,
        autoModActive,
        autoModInstructions,
        categoryScores,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export async function generateAutoModSettings(
  userId: number,
  provider: number,
  profileData: any
): Promise<void> {
  try {
    // Get the JWT token from your auth storage
    const authToken = Cookies.get('accessToken');

    // Make API call to new endpoint
    const response = await API.post(
      '/api/v1/automod/generate-auto-mod-settings',
      {
        userId,
        provider,
        profileData,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error processing profile data:', error);
    throw error;
  }
}

export const updateSocial = async (
  socialId: number,
  column: string,
  value: any
): Promise<any> => {
  const authToken = Cookies.get('accessToken');

  const response = await API.put(
    `/api/v1/social/update`,
    {
      socialId,
      column,
      value,
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return response;
};
